import { render, staticRenderFns } from "./trainingPlan.vue?vue&type=template&id=36c668d4&scoped=true"
import script from "./trainingPlan.vue?vue&type=script&lang=js"
export * from "./trainingPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c668d4",
  null
  
)

export default component.exports